import { render } from "./ShoppingCartStepThree.vue?vue&type=template&id=6521ba2a&scoped=true"
import script from "./ShoppingCartStepThree.vue?vue&type=script&lang=js"
export * from "./ShoppingCartStepThree.vue?vue&type=script&lang=js"

import "./ShoppingCartStepThree.vue?vue&type=style&index=0&id=6521ba2a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6521ba2a"

export default script